/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { usePopup } from '../../contexts/PopupContext';

import WabushPopup from './Wabush';
import CookiesPopup from './Cookies';

import styles from '../../../styles/modals/modals.scss';
import { getComponentFromName } from '../../lib/utils';

const components = { wabush: WabushPopup, cookies: CookiesPopup };
const propTypes = {
    popup: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    popup: null,
    className: null,
};

const Modals = ({ popup, className, ...props }) => {
    const { closePopup } = usePopup();
    const PopupComponent = getComponentFromName(popup, components, null);

    if (popup === null || PopupComponent === null) {
        return null;
    }

    const onClose = useCallback(() => {
        closePopup(popup);
    }, [popup, closePopup]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.bottom]: popup === 'cookies',
                    [className]: className !== null,
                },
            ])}
        >
            <PopupComponent {...props} onClose={onClose} />
        </div>
    );
};

Modals.propTypes = propTypes;
Modals.defaultProps = defaultProps;

export default Modals;
